import * as yup from 'yup'
import { PersonDto, DocumentTypeDto } from 'dtos'
import { ChargeDto } from './invoicing/ChargeDto'

export class DocumentDto {
  documentGuid?: string = undefined
  documentType?: DocumentTypeDto = undefined
  displayFileName?: string = undefined
  charge: ChargeDto | null = null
  additionalVins: string[] = []
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
  keyField1?: string = undefined
  keyField2?: string = undefined
  keyField3?: string = undefined
  keyField4?: string = undefined
  keyField5?: string = undefined
  keyField6?: string = undefined
  documentFile?: File = undefined
}

export const documentValidationSchema = yup.object({
  documentFile: yup
    .mixed()
    // @ts-ignore
    .test('File is required.', 'File', (value: File) => value)
    .required('File is required.'),
  files: yup.array().of(yup.mixed().required('File is required.')).min(1, 'At least one file is required.')
})
